export default "__VITE_ASSET__BzGYbs4q__"